<!-- <p>Erreur : {{ errorMessage }}</p> -->

<div class="error-dialog">
  <div class="error-dialog-icon">
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" fill="#C21636" />
      <path
        d="M8.36396 8.29289C7.97344 8.68342 7.97344 9.31658 8.36396 9.70711L10.4498 11.793L8.29289 13.9499C7.90237 14.3404 7.90237 14.9736 8.29289 15.3641C8.68342 15.7546 9.31658 15.7546 9.70711 15.3641L11.864 13.2072L14.0208 15.364C14.4113 15.7545 15.0445 15.7545 15.435 15.364C15.8256 14.9734 15.8256 14.3403 15.435 13.9497L13.2783 11.793L15.364 9.70726C15.7545 9.31673 15.7545 8.68357 15.364 8.29304C14.9734 7.90252 14.3403 7.90252 13.9497 8.29304L11.864 10.3788L9.77817 8.29289C9.38765 7.90237 8.75449 7.90237 8.36396 8.29289Z"
        fill="white"
      />
    </svg>
  </div>
  <div class="error-dialog-message">{{ errorMessage }}</div>
  <div class="error-dialog-close-button" (click)="closePopUp()">
    <svg
      width="49"
      height="49"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
        fill="#333333"
      />
    </svg>
  </div>
</div>
